class LovaCollectionRoot extends HTMLElement {
  static #validViews = new Set(['2', '4']);

  connectedCallback() {
    this.grid = this.querySelector('[data-lova-grid]');
    this.inputs = this.querySelectorAll('input[name="lova-grid-view"]');
    const stored = sessionStorage.getItem('lova-collection-view');
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    const fallback = isMobile
      ? this.dataset.defaultViewMobile || '2'
      : this.dataset.defaultView || '4';
    let initial = LovaCollectionRoot.#validViews.has(stored) ? stored : fallback;
    // Mobile Figma has no density control — keep 2-col grid
    if (isMobile) initial = '2';
    else if (!LovaCollectionRoot.#validViews.has(initial)) initial = '4';
    this.applyView(initial);
    this.addEventListener('change', this);
    window.LovaWishlist?.syncButtons(this);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this);
  }

  handleEvent(event) {
    if (event.type !== 'change') return;
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.name !== 'lova-grid-view') return;
    this.applyView(target.value);
    sessionStorage.setItem('lova-collection-view', target.value);
  }

  applyView(value) {
    const view = LovaCollectionRoot.#validViews.has(value) ? value : '4';
    if (this.grid) this.grid.dataset.view = view;
    this.inputs.forEach((input) => {
      input.checked = input.value === view;
    });
  }
}

if (!customElements.get('lova-collection-root')) {
  customElements.define('lova-collection-root', LovaCollectionRoot);
}
